import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
export const CopyToClipboard = ({ text }) => {
    const [copied, setCopied] = useState(false);
    const handleCopy = async (e) => {
        e.stopPropagation();
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    return (_jsx("button", { onClick: handleCopy, className: "text-primary-on-surface-text hover:text-primary-hover ml-1 shrink-0", "aria-label": "Copy to clipboard", children: copied ? _jsx(Check, { className: "size-3.5" }) : _jsx(Copy, { className: "size-3.5" }) }));
};
//# sourceMappingURL=copy-to-clipboard.js.map